import React, { useEffect, useState } from "react";

const testimonials = [
  {
    image: "https://randomuser.me/api/portraits/women/44.jpg",
    title: "Testimonials",
    quote:
      "The UI is super clean, and navigating between features feels natural. It really streamlined my workflow!",
    client: "Riya Patel - FinTech Pro",
  },
  {
    image: "https://randomuser.me/api/portraits/men/33.jpg",
    title: "Testimonials",
    quote:
      "Sukanya, you're a genius! The dashboard is exactly what I needed for my analytics setup. Thank you!",
    client: "Aman Singh - DataX Agency",
  },
  {
    image: "https://randomuser.me/api/portraits/women/68.jpg",
    title: "Testimonials",
    quote:
      "Simple, elegant, and efficient. It’s rare to find something that just works so seamlessly.",
    client: "Priya S. - HealthSphere",
  },
  {
    image: "https://randomuser.me/api/portraits/men/46.jpg",
    title: "Testimonials",
    quote:
      "I use this daily to track progress across teams. It's now an essential part of our internal workflow.",
    client: "Rahul Verma - CodeBridge",
  },
  {
    image: "https://randomuser.me/api/portraits/women/81.jpg",
    title: "Testimonials",
    quote:
      "Great job, Sukanya! The feature set is solid, and the support was lightning-fast. Highly recommended!",
    client: "Neha Joshi - BrandScale",
  },
];

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full flex justify-center items-center p-6">
      <div className="relative w-full overflow-hidden" style={{width: '88rem'}}>
        {/* Navigation buttons */}
        <button
          onClick={handlePrev}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-3xl font-bold text-gray-500 hover:text-gray-800 z-10"
        >
          &#8249;
        </button>

        <button
          onClick={handleNext}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-3xl font-bold text-gray-500 hover:text-gray-800 z-10"
        >
          &#8250;
        </button>

        {/* Carousel track */}
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="min-w-full bg-indigo-50 p-6 rounded-xl shadow-md flex flex-col md:flex-row items-center"
            >
              <div className="flex-shrink-0 p-5">
                <img
                  src={t.image}
                  alt={t.client}
                  className="w-32 h-32 md:w-40 md:h-40 rounded-full object-cover border-4 border-white shadow-md"
                />
              </div>
              <div className="p-6 text-center md:text-left flex-1">
                <h4 className="text-lg font-semibold text-gray-600">{t.title}</h4>
                <p className="text-xl font-medium text-gray-800 italic mt-2">"{t.quote}"</p>
                <p className="mt-4 text-sm text-gray-600">{t.client}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
